import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { InternalFieldName } from 'react-hook-form/dist/types/fields';
import InvoiceStatusState from '../../enums/InvoiceStatusState';
import Form from '../Crud/Form';

export interface InvoiceStatusFormFields {
  state: InvoiceStatusState | null;
  label: string;
}

interface InvoiceStatusFormProps {
  isLoading: boolean;
  title: string;
  formFields: InvoiceStatusFormFields;
  formErrors: Record<string, any>;
  onSubmit: (data: any) => void;
}

function addServerErrors<T>(
  errors: { [P in keyof T]?: string[] },
  setError: any
) {
  return Object.keys(errors).forEach((key) => {
    setError(key as keyof T, {
      type: 'server',
      message: errors[key as keyof T]!.join('. '),
    });
  });
}

export default function InvoiceStatusForm({
  isLoading,
  title,
  formFields,
  formErrors,
  onSubmit,
}: InvoiceStatusFormProps) {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
    reset,
  } = useForm<InvoiceStatusFormFields>();

  useEffect(() => {
    reset(formFields);
  }, [formFields]);

  useEffect(() => {
    let shouldFocus = true;
    Object.keys(formErrors || {}).forEach((field: InternalFieldName) => {
      addServerErrors(formErrors, setError);

      shouldFocus = false;
    });
  }, [formErrors]);

  return (
    <Form isLoading={isLoading} title={title} onSubmitCallback={() => {}}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor='inputLabel' className='form-label'>
            Status
          </label>
          <select
            className='form-select'
            aria-label='Selecione o Status'
            {...register('state', { required: true })}
          >
            <option>Selecione o Status</option>
            <option value={InvoiceStatusState.Blocked}>Bloqueado</option>
            <option value={InvoiceStatusState.Canceled}>Cancelado</option>
          </select>
          {errors.state && (
            <div id='emailHelp' className='form-text text-danger'>
              {errors.state.message}
            </div>
          )}
        </div>
        <div className='mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor='inputLabel' className='form-label'>
            Nome
          </label>
          <input
            {...register('label', { required: true })}
            className='form-control'
            id='inputLabel'
            placeholder='Nome'
            type='text'
            required
          />
          {errors.label && (
            <div id='emailHelp' className='form-text text-danger'>
              {errors.label.message}
            </div>
          )}
        </div>
        <div className='d-flex justify-content-end gap-2'>
          <Link to='/invoice-statuses' className='btn btn-secondary'>
            Cancelar
          </Link>
          <button type='submit' className='btn btn-primary'>
            Salvar
          </button>
        </div>
      </form>
    </Form>
  );
}
